var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 5.53906L1.9375 0.664062C1.25781 0.265625 0.25 0.664062 0.25 1.625V11.375C0.25 12.2656 1.1875 12.8047 1.9375 12.3594L10.1875 7.48438C10.9141 7.03906 10.9141 5.98438 10.1875 5.53906ZM1.375 11.1406V1.88281C1.375 1.76562 1.49219 1.69531 1.58594 1.76562L9.41406 6.38281C9.50781 6.45312 9.50781 6.57031 9.41406 6.64062L1.58594 11.2578C1.49219 11.3047 1.375 11.2578 1.375 11.1406Z",
    fill: "#0A3751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a549417881eefc06997e86864d7060a6.svg";
export { ForwardRef as ReactComponent };